
import { defineComponent } from "vue";

export default defineComponent({
  name: "Modal",
  props: {
    mostrar: {
      type: Boolean,
      required: true,
    },
  },
});
